import { TWhiteLabelStore } from '../white-label.model';

export function setPanelFont(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--panelFont', whiteLabel.data.panelFont);
}
